import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { moduloPerform } from '../../diccionarios/performValuesModulo';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class MantenedorIoIndustriasPlcService {

  tvcModulo: any = {};
  urlIndustrias: any = {};
  url: string;

  constructor(
    private _util: UtilsService,
    private _commom: CommonService,
    private http: HttpClient
  ) {
    this.tvcModulo = moduloPerform;
    this.urlIndustrias = this.tvcModulo.url.plcPerform;
    this.url = this._util.getUrlIoIndustrias();
  }

  getAllOrdenProceso() {
    return this._commom.peticionGetConHeader(this.url + this.urlIndustrias.ordenProceso);
  }

  getAllOrdenProceosNonProcesed(){
    return this._commom.peticionGetConHeader(this.url + this.urlIndustrias.ordenProceso+'/noproces');
  }

  getAllOrdenProceosNonProcesedLastWeek(){
    return this._commom.peticionGetConHeader(this.url + this.urlIndustrias.ordenProceso+'/noproces-lastweek');
  }

  enviarConfigPlc(innObjPlc: any) {
    return this._commom.peticionPostConHeader(this.url + this.urlIndustrias.perform+'/send-params', innObjPlc);
  }

  procesarOrdenProceso(idMaterial:string, idOrden:string, idLinea: number){
    return this._commom.peticionGetConHeader(this.url + this.urlIndustrias.ordenProceso + `/procesar/${idMaterial}`+`/${idOrden}`+`/${idLinea}`);
  }

  updatePlc(innObjPlc: any) {
    return this._commom.peticionPutConHeader(this.url + this.urlIndustrias.ordenProceso, innObjPlc);
  }

  deletePlc(innIdPlc: string) {
    return this._commom.peticionDeleteConHeader(this.url + this.urlIndustrias.ordenProceso + `/${innIdPlc}`);
  }

  
}
